import React from "react";
import "./Schedule.css";

class Schedule extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="section">
          <div className="container">
            <h1 className="title"> Programming </h1>
            <div className="columns">
              <div className="column">
                <div className="box has-background-white content">
                  <p className="subtitle">Coming Soon</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Schedule;
